import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `ImportarClientesExcel/descargarPlantillaExcelClientesExcel`, method: 'GET', body: null, token: token})
}
